import React from 'react'
import logo from "../images/si24-logo.svg";
import { Container, Image } from 'semantic-ui-react'
import { NavLink } from 'react-router-dom';

export default () => {
  return (
    <Container>
      <h1 className="not-found-header">403</h1>
      <p className="not-found-body">You do not have permission to access this page.</p>

      <NavLink className='not-found-link' to='/login'>
        <p>Return</p>
      </NavLink>

    </Container>
  )
}
